// The shop and upgrade pop-ups are nudges toward a destination the user may
// have already found on their own. Once they have been to the menu this
// session, pre-ordering has been offered and the drawer is just noise; same for
// the seat map and the upgrade/sale drawer.
//
// Session-scoped, not permanent: a visit means "they know it's there right
// now", which is a fact about this visit to the app, not about the user
// forever. usePopupTrigger's own `popup:<id>:viewed` flag stays in
// localStorage and remains the permanent dismissal.
//
// Deliberately NOT keyed by order/channel uid (unlike continue-watching): the
// rule is about the user having explored the destination at all, so any visit
// suppresses the nudge for every ticket in the session.
const visitedKey = (route: string) => `popup-route:${route}:visited`

// Routes whose pop-up nudge becomes redundant once visited.
export const FOOD_AND_DRINKS_ROUTE = '/food-and-drinks'
export const SEAT_MAP_ROUTE = '/seat-map'

export const markRouteVisited = (route: string) => {
  try {
    sessionStorage.setItem(visitedKey(route), '1')
  } catch {
    // sessionStorage can be unavailable (private mode); ignore.
  }
}

export const isRouteVisited = (route: string) => {
  try {
    return sessionStorage.getItem(visitedKey(route)) === '1'
  } catch {
    return false
  }
}
